import { useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import agent from '../../../app/api/agent'

function PostDetailsContact() {
  const { id } = useParams()
  const initialState = {
    postId: id,
    fullName: '',
    email: '',
    tel: '',
    message: '',
  }
  const [contact, setContact] = useState(initialState)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const { t } = useTranslation()

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setContact({ ...contact, [name]: value })
  }

  const handleSubmit = (e: any) => {
    setLoadingBtn(true)
    e.preventDefault()
    agent.Profile.sendMessage(contact)
      .then(() => {
        toast.success(t('message_sent'))
      })
      .finally(() => {
        setContact(initialState)
        setLoadingBtn(false)
      })
  }

  return (
    <Form onSubmit={handleSubmit}>
      <header>
        <h5>{t('contact_provider')}</h5>
      </header>
      <main>
        <Form.Control
          required
          onChange={handleInputChange}
          name='fullName'
          type='text'
          value={contact.fullName}
          placeholder={`${t('full_name') || ''} *`}
        />
        <Form.Control
          required
          onChange={handleInputChange}
          name='email'
          type='email'
          value={contact.email}
          placeholder={`${t('email') || ''} *`}
        />
        <Form.Control
          required
          onChange={handleInputChange}
          name='tel'
          type='tel'
          value={contact.tel}
          placeholder={`${t('tel') || ''} *`}
        />
        <Form.Control
          required
          onChange={handleInputChange}
          name='message'
          as='textarea'
          value={contact.message}
          rows={3}
          placeholder={`${t('message') || ''} *`}
        />
        <button disabled={loadingBtn} type='submit'>
          {loadingBtn ? <Spinner size='sm' animation='border' variant='light' /> : t('send')}
        </button>
      </main>
    </Form>
  )
}

export default PostDetailsContact
